// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
export type PageHeaderNavFragment = {
  __typename?: "Organization";
  permittedToCreateServers: boolean;
  servers: Array<{
    __typename?: "Server";
    id: string;
    humanId: string;
    name: string;
    clusterId?: string | null;
    hasRecentSnapshot: boolean;
    hasCriticalIssues: boolean;
    latestStats?: {
      __typename?: "PostgresServerStats";
      isPrimary: boolean;
    } | null;
  }>;
  serverGroups: Array<{
    __typename?: "ServerGroup";
    id: string;
    name: string;
    clusterId: string;
    permittedToEdit: boolean;
    primaryServerHumanId?: string | null;
    fallbackServerHumanId?: string | null;
    servers: Array<{
      __typename?: "Server";
      id: string;
      humanId: string;
      name: string;
      clusterId?: string | null;
      hasRecentSnapshot: boolean;
      hasCriticalIssues: boolean;
      latestStats?: {
        __typename?: "PostgresServerStats";
        isPrimary: boolean;
      } | null;
    }>;
  }>;
  customServerGroups: Array<{
    __typename?: "ServerGroup";
    id: string;
    name: string;
    permittedToEdit: boolean;
    fallbackServerHumanId?: string | null;
  }>;
};

export const PageHeaderNavFragmentDoc = gql`
  fragment PageHeaderNav on Organization {
    permittedToCreateServers
    servers(standalone: true) {
      id
      humanId
      name
      clusterId
      hasRecentSnapshot
      hasCriticalIssues
      latestStats {
        isPrimary
      }
    }
    serverGroups {
      id
      name
      clusterId
      permittedToEdit
      primaryServerHumanId
      fallbackServerHumanId
      servers {
        id
        humanId
        name
        clusterId
        hasRecentSnapshot
        hasCriticalIssues
        latestStats {
          isPrimary
        }
      }
    }
    customServerGroups {
      id
      name
      permittedToEdit
      fallbackServerHumanId
    }
  }
`;
